import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import AnalysisRunningAnimation from 'analysis-tool/ui/components/AnalysisRunningAnimation';
import {FONT_PROXIMA_18} from 'styles/FontConstants';

export default function RunningLayout({message}: {message: string}): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <AnalysisRunningAnimation />
      {message}
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 74,
    ...FONT_PROXIMA_18,
  },
});
